import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { SelectedProductContextFacade } from 'ish-core/facades/selected-product-context.facade';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { ProductView } from 'ish-core/models/product-view/product-view.model';
import { SharedModule } from 'ish-shared/shared.module';

import { ProductVariationListExportsModule } from '../../extensions/product-variation-list/exports/product-variation-list-exports.module';
import { RecentlyExportsModule } from '../../extensions/recently/exports/recently-exports.module';

import { ProductBundlePartsComponent } from './product-bundle-parts/product-bundle-parts.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { ProductLinksComponent } from './product-links/product-links.component';
import { ProductMasterVariationsComponent } from './product-master-variations/product-master-variations.component';
import { RetailSetPartsComponent } from './retail-set-parts/retail-set-parts.component';

@Component({
  selector: 'ish-product-page',
  templateUrl: './product-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: ProductContextFacade, useClass: SelectedProductContextFacade }],
  imports: [
    SharedModule,
    ProductDetailComponent,
    ProductBundlePartsComponent,
    RetailSetPartsComponent,
    FeatureToggleModule,
    ProductMasterVariationsComponent,
    ProductVariationListExportsModule,
    ProductLinksComponent,
    RecentlyExportsModule,
    AsyncPipe,
  ],
})
export class ProductPageComponent implements OnInit {
  productLoading$: Observable<boolean>;
  product$: Observable<ProductView>;

  private context = inject(ProductContextFacade);

  ngOnInit() {
    this.productLoading$ = this.context.select('loading');
    this.product$ = this.context.select('product');
  }
}
